import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Modal } from '@/shared/ui';

import { DoctorRow } from '@/entities/doctors';
import { OrganizationMember } from '@/entities/organization';

import styles from './ShowAllTreatingDoctorsModal.module.scss';

type ShowAllTreatingDoctorsModalProps = {
  className?: string;
  isOpen?: boolean;
  onClose?: () => void;
  treatingDoctors: OrganizationMember[];
  openRemoveDoctorModal: (doctorID: string) => void;
};

export const ShowAllTreatingDoctorsModal: FC<
  ShowAllTreatingDoctorsModalProps
> = (props) => {
  const {
    className,
    onClose,
    isOpen = false,
    treatingDoctors,
    openRemoveDoctorModal,
  } = props;

  const { formatMessage } = useIntl();

  return (
    <Modal
      data-component="show-all-treating-doctors-modal"
      className={cn(styles.container, className)}
      title={formatMessage({
        id: 'patientInfo.treatingDoctors',
        defaultMessage: 'Treating doctors',
      })}
      isOpen={isOpen}
      onCancel={onClose}
      hideFooter
    >
      <div className={styles.content}>
        {treatingDoctors.map((treatingDoctor) => {
          const isDeactivated = treatingDoctor.Status.case !== 'Active';
          return (
            <DoctorRow
              key={treatingDoctor.ID}
              doctor={treatingDoctor}
              disabled={isDeactivated}
              description={
                isDeactivated
                  ? formatMessage({
                      id: 'global.deactivated',
                      defaultMessage: 'Deactivated',
                    })
                  : undefined
              }
              onDelete={() => openRemoveDoctorModal(treatingDoctor.ID)}
            />
          );
        })}
      </div>
    </Modal>
  );
};
